'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var play = function play() {
  return import('@/page/play');
};
var playView = function playView() {
  return import('@/page/play-view');
};
var livePlay = function livePlay() {
  return import('@/page/live-play');
};
var speedTest = function speedTest() {
  return import('@/page/speed-test');
};
var appPolymer = function appPolymer() {
  return import('@/page/app-polymer');
};
var websiteDownload = function websiteDownload() {
  return import('@/page/website-download');
};
exports.default = [{
  path: '/play',
  name: 'play',
  component: play,
  childred: []
}, {
  path: '/livePlay',
  name: 'livePlay',
  component: livePlay,
  childred: []
}, {
  path: '/playView',
  name: 'playView',
  component: playView,
  childred: []
}, {
  path: '/speedTest',
  name: 'speedTest',
  component: speedTest,
  childred: []
}, {
  path: '/appPolymer',
  name: 'appPolymer',
  component: websiteDownload,
  childred: []
}, {
  path: '/websitedownload',
  name: 'websitedownload',
  component: appPolymer,
  childred: []
}];